import * as func from '../helpers/functions';
import messages from '../messages.js';

class RestrictPageInputs {
    static targetAttrName = 'data-rpi';

    #elements //本体
    #myAttrName //属性名
    #message; // メッセージ
    #radioStates; // ラジオボタングループ用

    constructor(elements, targetAttrName = null) {
        let obj = this;

        obj.elements = elements;
        obj.myAttrName = targetAttrName ? targetAttrName : obj.constructor.targetAttrName;
        obj.radioStates = {};

        for (var i = 0; i < obj.elements.length; i++) {
            obj.initItems(obj.elements[i]);
        }
    }

    initItems(trigger) {
        let obj = this;

        switch (trigger.tagName.toLowerCase()) {
            case 'select':
                trigger.addEventListener('input', function(e) {
                    obj.invokeSelect(this, true);
                });

                obj.invokeSelect(trigger, false);
                break;
            case 'input':
                switch (trigger.type) {
                    case 'checkbox':
                        trigger.addEventListener('change', function(e) {
                            obj.invokeCheckbox(this, true);
                        });
                        obj.invokeCheckbox(trigger, false);

                        break;
                    case 'radio':
                        trigger.addEventListener('change', function(e) {
                            obj.invokeCheckbox(this, true);
                        });
                        obj.initRadio(trigger, false);

                        break;
                    case 'hidden':
                    case 'text':
                        trigger.addEventListener('change', function(e) {
                            obj.invokeText(this, true);
                        });

                        obj.invokeText(trigger, false);

                        break;
                }
            default:
        }
    }

    invokeSelect(control, changed = true) {
        let obj = this,
            selected,
            options = control.selectedOptions;

        if (options.length == 0) {
            selected = '';
        } else {
            selected = options[0].value;
        }
        obj.invoke(control, selected, changed);
    }

    invokeCheckbox(control, changed = true) {
        let obj = this;
        const regex = /^.+\[(?:.*?)?\]$/;

        if (control.name.match(regex)) {
            // 複数選択時
            if (control.checked) {
                obj.invoke(control, control.value, changed);
            } else {
                obj.invoke(control, '', changed);
            }
        } else {
            // 単一選択時
            if (control.checked) {
                obj.invoke(control, control.value, changed);
            } else {
                let hidden = document.querySelector('input[type="hidden"][name="' + control.name + '"]');
                if (hidden) {
                    obj.invoke(control, hidden.value, changed);
                } else {
                    obj.invoke(control, '', changed);
                }
            }
        }
    }

    initRadio(control, changed = true) {
        let obj = this;
        const regex = /^.+\[(?:.*?)?\]$/;
        const triggerName = control.getAttribute(obj.getMyAttrName());

        if (Object.hasOwn(obj.radioStates, triggerName)) {
             if (obj.radioStates[triggerName] == true) {
                return;
             }
        }

        obj.radioStates[triggerName] = control.checked;

        if (control.checked) {
            obj.invoke(control, control.value, changed);
        } else {
            let hidden = document.querySelector('input[type="hidden"][name="' + control.name + '"]');
            if (hidden) {
                obj.invoke(control, hidden.value, changed);
            } else {
                obj.invoke(control, '', changed);
            }
        }
    }

    invokeText(control, changed = true) {
        let obj = this;
        obj.invoke(control, control.value, changed);
    }

    invoke(trigger, targetValue, changed = true) {
        let obj = this;

        const noinitIndentifierRegex = /_noinit$/;
        const triggerName = trigger.getAttribute(obj.getMyAttrName());
        const targetAttr = obj.getMyAttrName('-' + triggerName);
        const targets = document.querySelectorAll('[' + targetAttr + ']');

        for (var i = 0; i < targets.length; i++) {
            const rules = targets[i].getAttribute(targetAttr).split('|');
            for (var ruleIndex = 0; ruleIndex < rules.length; ruleIndex++) {
                const rule = rules[ruleIndex].split(':');
                if (rule.length < 2) {
                    throw 'invalid rpi rulel';
                }

                const triggerValues = rule[0].split(',');

                const actions = rule[1].split(',');
                for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
                    let item, actionName, actionflg;
                    item = actions[actionIndex].split('=');
                    actionName = item[0];
                    if (item.length > 1) {
                        actionflg = item[1];
                    }

                    if (actionName.match(noinitIndentifierRegex)) {
                        if (!changed) {
                            continue;
                        }

                        actionName = actionName.replace(noinitIndentifierRegex, '');
                    }

                    switch (actionName) {
                        case 'display':
                            if (triggerValues.includes(targetValue)) {
                                if (actionflg === 'true') {
                                    func.removeClass(targets[i], 'hide');
                                } else {
                                    func.addClass(targets[i], 'hide');
                                }
                            } else {
                                if (actionflg === 'true') {
                                    func.addClass(targets[i], 'hide');
                                } else {
                                    func.removeClass(targets[i], 'hide');
                                }
                            }

                            break;
                        case 'disabledifall':
                            if (obj.checkGroupTriggers(triggerName, triggerValues)) {
                                if (actionflg === 'true') {
                                    targets[i].disabled = true;
                                } else {
                                    targets[i].disabled = false;
                                }
                            } else {
                                if (actionflg === 'true') {
                                    targets[i].disabled = false;
                                } else {
                                    targets[i].disabled = true;
                                }
                            }

                            break;
                        case 'disabled':
                            if (triggerValues.includes(targetValue)) {
                                if (actionflg === 'true') {
                                    targets[i].disabled = true;
                                } else {
                                    targets[i].disabled = false;
                                }
                            } else {
                                if (actionflg === 'true') {
                                    targets[i].disabled = false;
                                } else {
                                    targets[i].disabled = true;
                                }
                            }

                            break;
                        case 'enablewith':
                            if (triggerValues.includes(targetValue)) {
                                if (targets[i].disabled) {
                                    targets[i].disabled = false;
                                    func.setValue(targets[i], actionflg);
                                }
                            } else {
                                targets[i].disabled = true;
                                func.clearControl(targets[i]);
                            }

                            break;
                        case 'elseenable':
                            if (triggerValues.includes(targetValue)) {
                                targets[i].disabled = true;
                            } else {
                                targets[i].disabled = false;
                            }

                            break;
                        case 'elseenablewith':
                            if (triggerValues.includes(targetValue)) {
                                targets[i].disabled = true;
                                func.clearControl(targets[i]);
                            } else {
                                if (targets[i].disabled) {
                                    targets[i].disabled = false;
                                    func.setValue(targets[i], actionflg);
                                }
                            }

                            break;
                        case 'changeval':
                            if (triggerValues.includes(targetValue)) {
                                func.setValue(targets[i], actionflg);
                            }
                            break;
                        case 'clearifall':
                            if (obj.checkGroupTriggers(triggerName, triggerValues)) {
                                func.clearControl(targets[i]);
                            }
                            break;
                        case 'clear':
                            if (triggerValues.includes(targetValue)) {
                                if (actionflg === 'self') {
                                    func.clearControl(targets[i]);
                                }
                            } else {
                                if (actionflg === 'else') {
                                    func.clearControl(targets[i]);
                                }
                            }
                            break;
                        case 'readonly':
                            if (triggerValues.includes(targetValue)) {
                                if (actionflg === 'true') {
                                    targets[i].readOnly = true;
                                } else {
                                    targets[i].readOnly = false;
                                }
                            } else {
                                if (actionflg === 'true') {
                                    targets[i].readOnly = false;
                                } else {
                                    targets[i].readOnly = true;
                                }
                            }
                            break;
                    }
                }
            }
        }
    }

    checkGroupTriggers(triggerName, targetValues) {
        let obj = this;

        let triggersInSameGroup = document.querySelectorAll('[' + obj.getMyAttrName() + '="' + triggerName + '"]'),
            all = true;

        for (var i = triggersInSameGroup.length - 1; i >= 0; i--) {
            if (!targetValues.includes(obj.getControlValue(triggersInSameGroup[i]))) {
                all = false;
                break;
            }
        }

        return all;
    }

    getControlValue(control) {
        switch (control.tagName.toLowerCase()) {
            case 'select':
                return control.value;
                break;
            case 'input':
                switch (control.type) {
                    case 'checkbox':
                        if (control.checked) {
                            return control.value;
                        } else {
                            let hidden = document.querySelector('input[type="hidden"][name="' + control.name + '"]');
                            if (hidden) {
                                return hidden.value
                            }
                        }

                        break;
                }
            default:
        }

        return '';
    }

    getMyAttrName(additional = '') {
        return this.myAttrName + additional;
    }

    static setup() {
        let attrName, elements;

        attrName = RestrictPageInputs.targetAttrName;
        elements = document.querySelectorAll('[' + attrName + ']');
        if (elements.length) {
            new RestrictPageInputs(elements);
        }
    }
}

export default RestrictPageInputs;
